<template>
  <li :class="{ 'not-children': !isChildren }">
    <template v-if="isChildren">
      <div
        :class="{
          'not-children': !isChildren,
          structures__btn: true,
          'structures__btn--disable': headerLevel === 0 || headerLevel >= 2
        }"
        :data-level="headerLevel"
        @click="toggleChildren"
        ref="listStructureBtn"
      ></div>
    </template>
    <div class="structures__item">
      <span class="type">{{ item.type }}</span>
      <template v-if="!isEmptyText && isOverTextMaxLength">
        <span class="text"
          >{{ item.text.substr(0, MAX_TDH_STRING_LENGTH) }}...</span
        >
        <span class="c-text--neutral">{{
          `(※${MAX_TDH_STRING_LENGTH + 1}文字以上は表示しません)`
        }}</span>
      </template>
      <template v-else-if="!isEmptyText">
        <span class="text">{{ item.text }}</span>
      </template>
      <template v-else>
        <span class="text">テキストが設定されていません。</span>
      </template>
    </div>
    <template v-if="isChildren">
      <ul>
        <ListItemRanksTitleHeaders
          v-for="(header, index) in item.children"
          :key="index"
          :item="header"
          ref="listItemRanksTitle"
          @displayBtn="displayBtn"
        />
      </ul>
    </template>
  </li>
</template>
<script>
import ListItemRanksTitleHeaders from '@/components/contentPlans/ListItemRanksTitleHeaders';
import { MAX_TDH_STRING_LENGTH } from '@/constants';

export default {
  // 再起的に呼び出すため、name属性を設定
  name: 'ListItemRanksTitleHeaders',
  props: ['item'],

  components: {
    ListItemRanksTitleHeaders
  },

  created() {
    if (this.isChildren && this.headerLevel >= 2) {
      this.displayBtn();
    }
  },

  data() {
    return {
      headerLevel:
        this.item.type && this.item.type.match('^h[1-5]{1}$')
          ? parseInt(this.item.type.replace('h', ''))
          : 0
    };
  },

  computed: {
    isEmptyText() {
      // 必要なプロパティがない場合は一旦falseを返す (returnで判定を1回にできるが条件式が複雑になるため)
      if (!this.item.isImage && !this.item.text) {
        return true;
      }

      // 画像あり、テキストなしの場合は空文字で表示するので判定はfalseを返す
      if (this.item.isImage && !this.item.text) {
        return false;
      }

      // 画像要素ではない場合、空値ではなくても改行のみとかの場合は空テキストと判定
      return !!(
        this.item.text.replace(/\r?\n/g, '') === '' &&
        this.item.isImage === false
      );
    },

    isChildren() {
      return !!(
        this.item.children &&
        this.item.children.length > 0 &&
        this.item.children[0].type !== undefined
      );
    },
    isOverTextMaxLength() {
      if (this.item.text) {
        return this.item.text.length > MAX_TDH_STRING_LENGTH;
      }
      return false;
    },
    MAX_TDH_STRING_LENGTH() {
      return MAX_TDH_STRING_LENGTH;
    }
  },

  methods: {
    isActive() {
      return !!this.$refs.listStructureBtn.classList.contains(
        'structures__btn--disable'
      );
    },

    toggleChildren() {
      if (this.isActive()) {
        this.$refs.listStructureBtn.classList.remove(
          'structures__btn--disable'
        );
      } else {
        this.$refs.listStructureBtn.classList.add('structures__btn--disable');
      }
    },

    toggleChildrenAll(isOpen) {
      // 子供のHタグリストが存在しない場合は処理終了
      if (!this.isChildren) {
        return;
      }

      // 全部開くモードの場合は全部開くのみ、元に戻すモードの場合は、h2タグまでは開いて、それ以下は閉じる
      if (isOpen || this.headerLevel < 2) {
        this.$refs.listStructureBtn.classList.remove(
          'structures__btn--disable'
        );
      } else {
        this.$refs.listStructureBtn.classList.add('structures__btn--disable');
      }

      for (let i = 0; i < this.item.children.length; i++) {
        this.$refs.listItemRanksTitle[i].toggleChildrenAll(isOpen);
      }
    },

    displayBtn() {
      this.$emit('displayBtn');
    }
  }
};
</script>
